<div class="d-flex flex-column h-100">
  <div class="modal-header pt-3">
    <h2 class="modal-title">Add Option</h2>
    <span role="button" class="ms-auto" (click)="close()">
      <svg-icon name="modal-close-menu" class="svg-32"></svg-icon>
    </span>
  </div>

  <div class="modal-body modal-body-fixed overflow-hidden overflow-y-auto">
    <div class="d-flex flex-column overflow-y-auto h-sm-100">
      @if (!filtersLoading() && !hasAnyOptions()) {
        <div class="alert alert-warning mb-3">
          This home has no options set up for its model and elevation, so there is nothing to filter. Options have to be
          assigned to the model and elevation first.
        </div>
      }
      <form class="p-3 bg-light rounded-4 mb-3" [formGroup]="filterForm">
        <div class="row gy-3">
          <div class="col-lg-2 col-md-4 col-sm-6">
            <label class="form-label">Rooms</label>
            <generic-dropdown
              class="w-100"
              placeholder="Filter by Room"
              [items]="rooms()"
              [allowSearch]="true"
              [clearable]="true"
              [disabled]="!hasAnyOptions()"
              [loading]="filtersLoading()"
              formControlName="room"
            />
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <label class="form-label">Category </label>
            <generic-dropdown
              class="w-100"
              placeholder="Filter by Category"
              [items]="categories()"
              [allowSearch]="true"
              [clearable]="true"
              [disabled]="!hasAnyOptions()"
              [loading]="filtersLoading()"
              formControlName="category"
            />
          </div>
          <div class="col-lg-2 col-md-4 col-sm-6">
            <label class="form-label">Subcategory</label>
            <generic-dropdown
              class="w-100"
              placeholder="Filter by Subcategory"
              [items]="subcategories()"
              [allowSearch]="true"
              [clearable]="true"
              [disabled]="!hasAnyOptions() || !subcategories().length"
              [loading]="filtersLoading()"
              formControlName="subcategory"
            />
          </div>
          <div class="col-auto align-self-end">
            <div class="form-check d-flex ps-0">
              <p-checkbox binary="true" formControlName="applyCutoff"></p-checkbox>
              <label
                class="form-check-label ms-2"
                role="button"
                (click)="filterForm.controls.applyCutoff.setValue(!filterForm.controls.applyCutoff.value)"
                >Apply Cutoff</label
              >
            </div>
          </div>

          <!--   <div class="col-auto align-self-end">

            <input
              type="text"
              placeholder="Search Options"
              [ngModel]="searchTerm()"
              (ngModelChange)="searchTerm.set($event)"
              class="form-control"
              [ngModelOptions]="{ standalone: true }"
            />
          </div> -->
        </div>
      </form>
      <div class="flex-fill h-100 overflow-hidden overflow-y-auto pe-2">
        <div class="row h-100">
          <div class="col-md-7 h-100 mb-2 mb-md-0">
            <div class="d-flex flex-column h-100">
              <div class="position-relative mb-2">
                <svg-icon
                  [name]="'search-topbar'"
                  class="position-absolute top-50 start-0 translate-middle-y ms-3 svg-24"
                ></svg-icon>
                <input
                  type="text"
                  class="form-control ps-5 rounded-5"
                  placeholder="Search Options"
                  [ngModel]="searchTerm()"
                  (ngModelChange)="searchTerm.set($event)"
                  [ngModelOptions]="{ standalone: true }"
                />
              </div>
              <div class="table-outer table-theme position-relative h-100 d-flex flex-column flex-fill">
                @if (isLoading()) {
                  <div class="d-flex align-items-center justify-content-center flex-fill text-muted fs-14">
                    Loading options...
                  </div>
                } @else if (loadError()) {
                  <div class="alert alert-danger m-3">
                    {{ loadError() }}
                  </div>
                } @else if (!products().length) {
                  <div
                    class="d-flex flex-column align-items-center justify-content-center flex-fill text-muted bg-light p-3 text-center"
                  >
                    <i class="bi bi-info-circle fs-48"></i>
                    No options available for the selected model and elevation.
                  </div>
                } @else {
                  <div class="table-responsive h-100">
                    <p-table [value]="products()" [scrollable]="true">
                      <ng-template pTemplate="header">
                        <tr>
                          <!-- <th style="width: 120px">Image</th> -->
                          <th pSortableColumn="code">Option Code <p-sortIcon field="code"></p-sortIcon></th>
                          <th>Selected</th>
                          <th pSortableColumn="unitPrice">Unit Price <p-sortIcon field="unitPrice"></p-sortIcon></th>
                          <th pSortableColumn="description">
                            Description <p-sortIcon field="description"></p-sortIcon>
                          </th>
                          <th pSortableColumn="category">Category <p-sortIcon field="category"></p-sortIcon></th>
                          <th pSortableColumn="subcategory">
                            Subcategory <p-sortIcon field="subcategory"></p-sortIcon>
                          </th>
                          <th pSortableColumn="type">Type <p-sortIcon field="type"></p-sortIcon></th>
                          <th pSortableColumn="uom">UoM <p-sortIcon field="uom"></p-sortIcon></th>
                          <th pSortableColumn="selectionRequired" pFrozenColumn alignFrozen="right">
                            Attribute Required <p-sortIcon field="selectionRequired"></p-sortIcon>
                          </th>
                        </tr>
                      </ng-template>
                      <ng-template pTemplate="body" let-product>
                        <tr
                          class="table-row-selectable"
                          role="button"
                          (click)="addProduct(product)"
                          ngbTooltip="click to add this product"
                          placement="top-start"
                        >
                          <!-- <td class="text-center" (click)="$event.stopPropagation()">
                            @if (hasProductImages(product)) {
                              <lib-image-preview
                                [images]="getProductPreviewImages(product)"
                                [title]="product.description || product.code"
                                [subheadingTemplate]="productPreviewSubheading"
                              >
                                <ng-template #productPreviewSubheading>
                                  <div class="d-flex flex-wrap gap-3 text-muted small">
                                    @if (product.category) {
                                      <span
                                        >Category: <span class="text-dark">{{ product.category }}</span></span
                                      >
                                    }
                                    @if (product.subcategory) {
                                      <span
                                        >Subcategory: <span class="text-dark">{{ product.subcategory }}</span></span
                                      >
                                    }
                                  </div>
                                </ng-template>
                                <div
                                  class="d-flex align-items-center justify-content-center cursor-pointer mx-auto"
                                  style="height: 60px; width: 60px"
                                  ngbTooltip="Click to view all images"
                                  placement="top"
                                >
                                  <img
                                    [src]="getFirstImage(product)!.document.directUrl"
                                    alt="Product image"
                                    class="img-fluid rounded"
                                    style="max-height: 100%; max-width: 100%; object-fit: cover"
                                  />
                                </div>
                              </lib-image-preview>
                            } @else {
                              <div
                                class="d-flex align-items-center justify-content-center bg-light rounded"
                                style="height: 60px; width: 60px; margin: 0 auto"
                              >
                                <i class="bi bi-image text-muted"></i>
                              </div>
                            }
                          </td> -->
                          <td>
                            {{ product.code }}
                          </td>
                          <td class="text-center">
                            @if (isProductSelected(product)) {
                              <i class="bi bi-check-circle-fill text-success"></i>
                            }
                          </td>
                          <td>{{ product.unitPrice | currencyFormat }}</td>
                          <td>{{ product.description }}</td>
                          <td>{{ product.category }}</td>
                          <td>{{ product.subcategory }}</td>
                          <td>{{ product.type }}</td>
                          <td>{{ product.uom }}</td>
                          <td class="text-center" pFrozenColumn alignFrozen="right">
                            {{ product.selectionRequired ? 'Yes' : 'No' }}
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-sm col-md-5 h-100 mt-3 mt-sm-0">
            <div class="card border-dotted h-100 rounded-4 overflow-hidden">
              <div
                class="card-header py-3 border-0 d-flex align-items-center justify-content-between gap-2 position-relative"
              >
                <h4 class="mb-0 d-flex align-items-center gap-1 text-nowrap">
                  Selected Products:
                  @if (selectedCount() > 0) {
                    <span class="fw-500">{{ selectedCount() }}</span>
                  }
                  @if (getTotalValidationErrors() > 0) {
                    <span class="fw-500 text-danger position-absolute bottom-0 mb-2 fs-12 ms-1"
                      >{{ getTotalValidationErrors() }} missing fields</span
                    >
                  }
                </h4>
                <span class="fw-400 fs-16 d-flex align-items-center gap-2 text-nowrap ms-auto">
                  Total:
                  <span class="fw-500 fs-20 text-success">{{ totalSelectedProductsPrice() | currencyFormat }}</span>
                </span>
              </div>
              <div class="card-body p-2 overflow-y-auto h-100">
                @if (selectedCount()) {
                  <div class="d-flex flex-column gap-2">
                    @for (entry of selectedEntries(); track entry.id) {
                      <app-selected-product-panel
                        [addendumId]="addendumId()!"
                        [product]="entry.product"
                        [selectionForm]="entry.form"
                        [submitAttempted]="submitAttempted()"
                        [hasValidationErrors]="hasProductValidationErrors(entry.form)"
                        [validationErrorCount]="getProductValidationErrorCount(entry.form)"
                        [showDeleteIcon]="true"
                        (removeRequested)="removeProduct(entry.id)"
                      />
                    }
                  </div>
                } @else {
                  <div class="d-flex flex-column align-items-center justify-content-center h-100 p-3 text-center">
                    <div class="wh-48 rounded-5 bg-gray-200 d-flex align-items-center justify-content-center mb-3">
                      <i class="bi bi-cart-x fw-500 text-muted"></i>
                    </div>
                    <p class="fs-14 fw-500 text-muted mb-0">No products selected</p>
                    <p class="fs-12 text-muted mb-0">click any product row to select</p>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-shadow" type="button" (click)="close()">Cancel</button>
    <button
      class="btn btn-primary"
      type="button"
      appBtnLoader="deal-save-addendum-options"
      (click)="save()"
      [disabled]="isSaving() || !selectedCount()"
    >
      {{ isSaving() ? 'Saving...' : 'Save Options' }}
    </button>
  </div>
</div>
